import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extract strain name from URL
  const strainMap = {
    '/mimosa': 'Mimosa',
    '/max-ac': 'Max AC'
  };
  
  const displayName = strainMap[location.pathname] || '';

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/login');
  };

  return (
    <header className="top-header">
      <div className="header-inner">
        <div className="header-logo">
          <img src="/header_logo.png" alt="Cannaverum" className="logo-img" />
          {displayName && (
            <div className="strain-title">
              {displayName}
            </div>
          )}
        </div>

        <div className="header-search-wrapper">
          <input 
            type="text"
            className="header-search" 
            placeholder="Search strains, people, tools..." 
          />
        </div>

        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>
    </header>
  );
}
